if (!customElements.get('vat-invoice-fields')) {
  class VatInvoiceFields extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-vat-toggle]');
      this.fields = this.querySelector('[data-vat-fields]');
      this.status = this.querySelector('[data-vat-status]');
      this.inputs = Array.from(this.querySelectorAll('[data-vat-field]'));
      this.timer = null;
      this.pendingSave = null;

      this.toggle?.addEventListener('change', () => {
        this.updateVisibility();
        this.scheduleSave(0);
      });
      this.inputs.forEach((input) => {
        input.addEventListener('input', () => {
          input.setCustomValidity('');
          this.scheduleSave(450);
        });
        input.addEventListener('change', () => this.scheduleSave(0));
      });
      this.updateVisibility();
    }

    invoiceRequested() {
      return Boolean(this.toggle?.checked);
    }

    updateVisibility() {
      const enabled = this.invoiceRequested();
      if (this.fields) this.fields.hidden = !enabled;
      this.inputs.forEach((input) => {
        input.required = enabled;
        if (!enabled) input.setCustomValidity('');
      });
      window.requestAnimationFrame(() => {
        const summary = this.closest('.cart-summary__inner, .cart-drawer__summary') || this.parentElement;
        const accelerated = summary?.querySelector('.additional-checkout-buttons');
        const inpostRequested = Boolean(summary?.querySelector('allprod-inpost-picker [data-inpost-toggle]')?.checked);
        if (accelerated) accelerated.hidden = enabled || inpostRequested;
      });
    }

    attributesPayload() {
      const enabled = this.invoiceRequested();
      const attributes = { 'Faktura VAT': enabled ? 'Tak' : '' };
      this.inputs.forEach((input) => {
        attributes[input.dataset.vatField] = enabled ? input.value.trim() : '';
      });
      return attributes;
    }

    validateInvoice() {
      if (!this.invoiceRequested()) return true;

      const nipInput = this.querySelector('[data-vat-field="NIP"]');
      if (nipInput) {
        const nip = nipInput.value.replace(/\D/g, '');
        let validNip = nip.length === 10;
        if (validNip) {
          const weights = [6, 5, 7, 2, 3, 4, 5, 6, 7];
          const checksum = weights.reduce((sum, weight, index) => sum + weight * Number(nip[index]), 0) % 11;
          validNip = checksum !== 10 && checksum === Number(nip[9]);
        }
        nipInput.setCustomValidity(validNip ? '' : 'Wpisz prawidłowy polski NIP (10 cyfr).');
      }

      const invalid = this.inputs.find((input) => !input.reportValidity());
      invalid?.focus();
      return !invalid;
    }

    scheduleSave(delay) {
      window.clearTimeout(this.timer);
      this.timer = window.setTimeout(() => this.save(), delay);
    }

    async save() {
      window.clearTimeout(this.timer);
      if (this.pendingSave) await this.pendingSave;

      this.status.textContent = 'Zapisywanie danych faktury…';
      this.pendingSave = fetch(this.dataset.updateUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: this.attributesPayload() }),
      });

      try {
        const response = await this.pendingSave;
        if (!response.ok) throw new Error('Nie udało się zapisać danych faktury.');
        this.status.textContent = this.invoiceRequested() ? 'Dane faktury zapisane.' : '';
      } catch (error) {
        this.status.textContent = 'Nie udało się zapisać danych faktury. Spróbuj ponownie.';
        throw error;
      } finally {
        this.pendingSave = null;
      }
    }
  }

  customElements.define('vat-invoice-fields', VatInvoiceFields);

  const checkoutBypass = new WeakSet();
  document.addEventListener('click', async (event) => {
    const button = event.target.closest?.('button[name="checkout"]');
    if (!button || checkoutBypass.has(button)) {
      if (button) checkoutBypass.delete(button);
      return;
    }

    const summary = button.closest('.cart-summary__inner, .cart-drawer__summary') || document;
    const invoice = summary.querySelector('vat-invoice-fields');
    if (!invoice || !invoice.invoiceRequested()) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    if (!invoice.validateInvoice()) return;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    try {
      await invoice.save();
      checkoutBypass.add(button);
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.click();
    } catch (error) {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  }, true);
}
